class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.loadMoreProducts.bind(this));
    this.grid = document.getElementById('product-grid');
  }

  async loadMoreProducts() {
    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');

    const nextUrl = this.button.dataset.nextUrl;
    if (!nextUrl) return;

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const nextDocument = parser.parseFromString(text, 'text/html');

      const newProducts = nextDocument.querySelectorAll('#product-grid > li');
      const newNextUrl = nextDocument.querySelector('load-more-button button')?.dataset.nextUrl;

      newProducts.forEach(product => {
        this.grid.appendChild(product);
      });

      if (newNextUrl) {
        this.button.dataset.nextUrl = newNextUrl;
        this.button.removeAttribute('disabled');
        this.button.classList.remove('loading');
      } else {
        this.button.classList.add('hidden');
        this.remove();
      }

      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(); 
      }

    } catch (error) {
      console.error('Error loading more products:', error);
      this.button.removeAttribute('disabled');
      this.button.classList.remove('loading');
    }
  }
}

customElements.define('load-more-button', LoadMore);
